import React from "react";
import Popover from "~/common/Popover";
export default () => <Popover title="Lot Pricing" triggerElement={(ref: React.RefObject<HTMLAnchorElement>) => <a className="more-info" href="#lot-pricing-info" ref={ref}>
        <i className="icon-question" />
      </a>} options={{
  placement: "bottom"
}}>
    <div>
      Lot pricing allows you to buy an item in a set bulk quantity to save
      money. We list the amount of product you need to purchase in order to
      receive lot pricing under the orange ribbon, so you always know how to get
      the best deal. The same discount is applied for each lot you purchase.
    </div>
  </Popover>;